export default "__VITE_ASSET__DPsrcwY7__"